export default __webpack_public_path__ + "static/media/mulmet_karier.2ad8592f.png";